import ApiService from './ApiService';

export default class BikeApi extends ApiService {
    constructor() {
        super('');
    }

    getAllBike(payload) {
        return this.get('system/bikes', payload);
    }

    createBikeEk(payload) {
        return this.post('system/bikes-ek', payload);
    }

    createBikeGas(payload) {
        return this.post('system/bikes-gas', payload);
    }

    checkBikeHasBookingBeforeOff(payload) {
        return this.get(`system/bikes/check-bike-order/${payload.id}`);
    }

    updateBikeEk(payload) {
        const { id, ...rest } = payload;
        return this.put(`system/bikes-ek/${id}`, rest);
    }

    updateBikeGas(payload) {
        const { id, ...rest } = payload;
        return this.put(`system/bikes-gas/${id}`, rest);
    }

    getBikeDetail(id) {
        return this.get(`system/bikes/${id}`);
    }

    unregisterLocation(payload) {
        return this.post('system/locations/unregister/bikes', payload);
    }

    registerLocation(payload) {
        return this.post('system/locations/register/bikes', payload);
    }

    getNonRentalDateSetting(payload) {
        const { id, ...rest } = payload;
        return this.get(`system/non-rental-date-bikes/${id}`, rest);
    }

    createNonRentalDate(payload) {
        const { id, ...rest } = payload;
        return this.put(`system/non-rental-date-bikes/${id}`, rest);
    }

    updateNonRentalDate(payload) {
        return this.put('system/non-rental-date-list-bikes', payload);
    }

    resetNonRentalDate(payload) {
        const { bikeId, ...rest } = payload;
        return this.delete(`system/non-rental-date-bikes/${bikeId}`, rest);
    }

    addRecommendation(payload) {
        const { id, isRecommendation } = payload;
        return this.put(`system/ad-recommendation-bikes/${id}`, { isRecommendation });
    }

    deleteBike(id) {
        return this.delete(`system/bikes/${id}`);
    }

    reSendApproveBike(id) {
        return this.put(`system/resend-approve-bikes/${id}`);
    }

    getListModelName(payload) {
        return this.get('bikes/modelnames', payload);
    }

    getListModelNameIncluesDelete(payload) {
        return this.get('bikes/modelnames-inclues-delete', payload);
    }
}
